import {Banner} from './banner.js';
export class BannerMcsneakpicbanner extends Banner {
	init() {
		super.init();
		this.$root.on('click', () => {
			this.open_dialog();
		})
	}
	open_dialog() {
		yalwa.basics.ls_set('sneakpic_intro_shown', true);
		const sneakpic_eplain_plp = document.querySelector('.js-sneakpic_explanation_plp');
		sneakpic_eplain_plp.show_modal();
		
		sneakpic_eplain_plp.addEventListener('plp_confirm', (event) => {
			jQuery('.js-attachment_send_sneakpic').trigger('click')
		}, {
			once: true
		});
	}
	close() {
		super.close();
		this.$root.addClass('sneakpic_banner--disabled');
		yalwa.basics.ls_set('sneakpic_promo_dismissed', true);
		jQuery.post('/api/ajax/general', {action: 'dismiss_sneakpic_promo'});
	}
	show() {
		if (yalwa.basics.ls_get('sneakpic_promo_dismissed')) {
			this.$root.addClass('sneakpic_banner--disabled');
			return;
		}
		this.$root.removeClass('sneakpic_banner--disabled');
		super.show();
	}
}
